import type { ImportFormat } from '../api/agent';

export const IMPORT_TYPES = {
    csv_xlsx: { label: 'Fitment spreadsheet', fileFormat: 'CSV/XLSX' },
    collection_mappings_csv_xlsx: { label: 'Collection mappings', fileFormat: 'CSV/XLSX' },
    configurator_data_csv_xlsx: { label: 'Configurator data', fileFormat: 'CSV/XLSX' },
    aces_xml: { label: 'ACES catalog', fileFormat: 'XML' },
    atd_price_file: { label: 'ATD pricing', fileFormat: 'ATD price file' },
    product_tags: { label: 'Shopify product tags', fileFormat: null },
    fitment_export: { label: 'Fitment export', fileFormat: 'CSV' },
} as const satisfies Record<ImportFormat, { label: string; fileFormat: string | null }>;

export const getImportTypeLabel = (format: string): string =>
    Object.entries(IMPORT_TYPES).find(([key]) => key === format)?.[1].label ?? 'Unknown import type';
